// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n[data-v-37175cd6] .el-tag {\n  background-color: #d5fadd !important;\n  color: #06873d;\n}\n[data-v-37175cd6] .el-tag .el-tag__close {\n  color: #08a94c !important;\n  font-size: medium;\n  background-color: transparent !important;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
